/**
 * Utility to format error messages
 * Useful for error actions in epics
 *
 * @author nikola
 * */
export function formatError(error, options = {}) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { includeStatusCode, defaultMessage = "" } = options;
    // BaseQueryError
    if ("data" in error) {
        const { status, data } = error;
        const message = (data === null || data === void 0 ? void 0 : data.toString()) || defaultMessage;
        return includeStatusCode ? `${status}: ${message}` : message;
    }
    const serializedErrorCode = "code" in error ? (_a = error.code) !== null && _a !== void 0 ? _a : 0 : 0;
    const status = "isAxiosError" in error ? (_b = error.response) === null || _b === void 0 ? void 0 : _b.status : serializedErrorCode;
    const message = (_g = ("isAxiosError" in error
        ? (_e = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorMessage) !== null && _e !== void 0 ? _e : (_f = error.response) === null || _f === void 0 ? void 0 : _f.data
        : error.message)) !== null && _g !== void 0 ? _g : defaultMessage;
    return includeStatusCode ? `${status}: ${message}` : message;
}
//# sourceMappingURL=errorHelpers.js.map